<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="260"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        class="admin-icon-button"
        v-bind="attrs"
        v-on="on"
      >
        <v-avatar
          size="34"
          color="primary"
        >
          <span class="white--text text-caption font-weight-bold">{{ initials }}</span>
        </v-avatar>
      </v-btn>
    </template>

    <v-list class="py-0">
      <div class="d-flex align-center px-4 py-4">
        <v-avatar
          size="42"
          color="primary"
        >
          <span class="white--text font-weight-bold">{{ initials }}</span>
        </v-avatar>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align:middle"
        >
          <span class="text--primary font-weight-semibold mb-n1">
            {{ displayName }}
          </span>
          <small class="text--disabled">{{ displayEmail }}</small>
        </div>
      </div>

      <v-divider></v-divider>

      <v-list-item
        link
        @click="logout()"
      >
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Çıkış Yap</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mdiLogoutVariant } from '@mdi/js'
import { getPanelSession, logoutPanelSession } from '@/utils/panelSession'

export default {
  data() {
    return {
      currentUser: null,
      icons: {
        mdiLogoutVariant,
      },
    }
  },
  computed: {
    displayName() {
      const fullName = [this.currentUser?.name, this.currentUser?.surname]
        .filter(Boolean)
        .join(' ')

      return fullName || 'Admin Kullanıcı'
    },
    displayEmail() {
      return this.currentUser?.email || 'panel@adverport.com'
    },
    initials() {
      const value = this.displayName
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part.charAt(0))
        .join('')
        .toUpperCase()

      return value || 'AP'
    },
  },
  mounted() {
    this.currentUser = getPanelSession()
  },
  methods: {
    async logout() {
      await logoutPanelSession()
      this.$router.push({ name: 'login' })
    },
  },
}
</script>

<style lang="scss">
.user-profile-menu-content {
  border-radius: 20px !important;

  .v-list {
    background: transparent !important;
  }

  .v-list-item {
    min-height: 3rem !important;
  }
}
</style>
